import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";

export const FOOTER_SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/coin_mbx/", icon: Instagram, testId: "social-instagram" },
  { label: "Youtube", href: "https://www.youtube.com/@MegabyteDigispaceTechnologies", icon: Youtube, testId: "social-youtube" },
  { label: "Linkedin", href: "https://www.linkedin.com/company/coinmbx/", icon: Linkedin, testId: "social-linkedin" },
  { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61573223249368", icon: Facebook, testId: "social-facebook" },
];

/** Icon row — compact footer layout */
export function FooterSocialIcons() {
  return (
    <div className="flex flex-wrap gap-2.5" data-testid="footer-social-icons">
      {FOOTER_SOCIALS.map(({ label, href, icon: Icon, testId }) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          title={label}
          data-testid={testId}
          className="flex h-10 w-10 items-center justify-center rounded-full bg-white border border-[#D8D6E5] text-cm-blue hover:border-cm-blue hover:bg-cm-lavender/70 transition-colors"
        >
          <Icon size={17} />
        </a>
      ))}
    </div>
  );
}

/** Legacy list layout (kept for reuse elsewhere if needed) */
export default function FooterSocials() {
  return (
    <div data-testid="footer-socials">
      <FooterSocialIcons />
    </div>
  );
}
